import React, { useEffect } from "react";
import axiosClient from "../libs/axiosClient";
import { setToken } from "./auth";
import { handleRedirectUrlCheck } from "../common/redirectUrlCheck";

const LINE_CLIENT_ID = "2006748117";
const LINE_REDIRECT_URI = `${window.location.origin}/auth/line/callback`;

export const LINE_AUTH_URL = `https://access.line.me/oauth2/v2.1/authorize?response_type=code&client_id=${LINE_CLIENT_ID}&redirect_uri=${LINE_REDIRECT_URI}&scope=profile%20openid%20email&state=randomStateString`;

function Line() {
  useEffect(() => {
    let params = new URL(document.URL).searchParams;
    let code = params.get("code");

    axiosClient
      .post(
        "api/v1/auth/login/line",
        {
          code: code,
          redirect_uri: LINE_REDIRECT_URI,
        },
        {
          headers: {
            'Access-Control-Allow-Origin': 'https://api.cheongdamsecret.com',
          },
          withCredentials: true,
        },
      )
      .then((res) => {
        setToken(res.data);
        console.log("토큰: ", res.data);
        let rurl = localStorage.getItem("rurl");
        if (handleRedirectUrlCheck(rurl || "/"))
          window.location.href = rurl || "/";
        else window.location.href = "/";
      })
      .catch((err) => {
        alert(err.response?.data?.detail || "An error occurred during login.");
        window.location.href = "/login";
      });
  }, []);

  return <div></div>;
}

export default Line;
